import axios from 'axios';
import { storage } from '../utils/storage';

const _raw = process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:8000');
// Upgrade http → https when page is served over HTTPS to avoid mixed-content blocks
const BASE = (typeof window !== 'undefined' && window.location.protocol === 'https:')
  ? _raw.replace(/^http:/, 'https:')
  : _raw;

const api = axios.create({ baseURL: BASE });

api.interceptors.request.use((config) => {
  const token = storage.get('token');
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  // Multi-tenant: the org chosen in the topbar scopes every request.
  // Absent header = "all my organizations" mode (backend aggregates).
  const activeOrg = storage.getJSON('active_org');
  if (activeOrg?.id && config.url !== '/api/auth/logout') config.headers['X-Active-Org'] = activeOrg.id;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const hadToken = !!storage.get('token');
      const isAuthCall = (err.config?.url || '').includes('/api/auth/');
      // Only treat a 401 as an expired session when the user actually had a
      // token and the failing call wasn't the sign-in flow itself (a bad login
      // returns 401 too, and the login page surfaces that error on its own).
      if (hadToken && !isAuthCall) {
        storage.remove('token');
        storage.remove('user');
        storage.remove('active_org');
        const onLogin = typeof window !== 'undefined' &&
          window.location.pathname.startsWith('/login');
        if (!onLogin) {
          // Flag picked up by the login page to explain the redirect instead
          // of silently dumping the user back at sign-in.
          storage.set('session_expired', '1');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { BASE };
